import {
  Box,
  Chip,
  FormControl,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import {Add as AddIcon} from "@mui/icons-material";
import React, {useState} from "react";
import style from "../../assets/css/global-fields.module.scss";

const GlobalMultiTextField = ({
  type = "text", // Default type is 'text'
  id, // id of the input (Mandatory)
  label, // Optional: Label for the input
  variant = "outlined",
  name, // Name for the input field
  values = [], // Current list of values
  onChange, // Function to update values
  maxValues = 20, // Max allowed values
  error, // Error state
  helperText, // Helper text
  placeH = "Press Enter OR Click +Add to add multiple Members.",
}) => {
  const [inputValue, setInputValue] = useState("");
  // console.log("values", values);
  // const handleInputChange = (e) => {
  //   // console.log("A 1")
  //   setInputValue(e.target.value);
  // };

  // const handleKeyDown = (e) => {
  //   //console.log("A 2", e.key === "Enter", inputValue.trim(), values?.length, maxValues)

  //   if (e.key === "Enter" && inputValue.trim() && values?.length < maxValues) {
  //     //console.log("A 3")

  //     //e.preventDefault();
  //     onChange([...values, inputValue.trim()]);
  //     setInputValue("");
  //   }
  // };

  const handleDelete = (val) => {
    setInputValue("");
    onChange(values.filter((item) => item !== val));
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleBlur = () => {
    // If first value is being added
    if (values?.length === 0 && inputValue.trim()) {
      onChange([inputValue.trim()]);
      setInputValue("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim() && values?.length < maxValues) {
      e.preventDefault();
      onChange([...values, inputValue.trim()]);
      setInputValue("");
    }
  };
  return (
    <div className={style.proposalTextField}>
      <FormControl fullWidth className="TextFieldPosiRela">
        <TextField
          id={id}
          type={type}
          variant={variant}
          placeholder={placeH}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          label={label}
          name={name}
          error={error}
          helperText={
            helperText || (values?.length > 19 ? `Max Limit ${maxValues}` : "")
            // : "Press Enter to add multiple Members.")
          }
          disabled={values?.length >= maxValues}
          inputProps={{maxLength: 30}}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    // onClick={() => handleKeyDown({key: "Enter"})}
                    onClick={() =>
                      handleKeyDown({key: "Enter", preventDefault: () => {}})
                    }
                    disabled={!inputValue.trim() || values?.length >= maxValues}
                    sx={{
                      backgroundColor: "transparent",
                      // "&:hover": {
                      //   backgroundColor: "transparent", // remove hover background
                      // },
                      padding: 0.5, // optional: reduces padding if needed
                      borderRadius: "3px",
                    }}
                  >
                    <AddIcon style={{fontSize: 18}} />
                    <span style={{fontSize: 16}}>Add</span>
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
        <Box sx={{display: "flex", gap: 1, flexWrap: "wrap", mt: 1}}>
          {values?.length
            ? values.map((val, index) => (
                <Chip
                  size="small"
                  key={index}
                  label={val}
                  onDelete={() => handleDelete(val)}
                />
              ))
            : null}
        </Box>
      </FormControl>
    </div>
  );
};

export default GlobalMultiTextField;

// import { Box, Chip, FormControl, TextField, InputAdornment, IconButton } from "@mui/material";
// import { Add as AddIcon } from "@mui/icons-material";
// import React, { useState } from "react";
// import style from "../../assets/css/global-fields.module.scss";

// const GlobalMultiTextField = ({
//   placeH, // Placeholder text (Mandatory)
//   type = "text", // Default type is 'text'
//   onChange, // Function to handle change event (Mandatory)
//   onBlur, // Function to handle blur event (Mandatory)
//   value, // Value to bind to the input (Mandatory)
//   id, // id of the input (Mandatory)
//   inputRef, // Optional: Reference for the input
//   label, // Optional: Label for the input
//   error = false, // Default error state
//   helperText, // Optional: Helper text to show error messages
//   name, // Optional: Name for the input field (mandatory in Formik)
//   fullWidth = true, // Default full width
//   disabled = false, // Disabled state
//   cssClass, // Custom CSS class
//   values = [], // List of added values
//   onKeyDown, // Key event handler
//   handleDelete, // Function to delete values
//   maxValues = 10, // Max allowed values
// }) => {
//   const [inputValue, setInputValue] = useState("");

//   const handleInputChange = (e) => {
//     const inputValue = e.target.value;

//     if (type === "number") {
//       const numericValue = inputValue.replace(/[^0-9]/g, "");
//       onChange({ target: { name: e.target.name, value: numericValue } });
//     } else {
//       onChange(e);
//     }
//     setInputValue(e.target.value);
//   };

//   const handleAddValue = () => {
//     if (inputValue.trim() && values?.length < maxValues) {
//       onChange({ target: { name, value: [...values, inputValue.trim()] } });
//       setInputValue("");
//     }
//   };

//   return (
//     <div className={style.proposalTextField}>
//       <FormControl fullWidth={fullWidth} className="TextFieldPosiRela">
//         <TextField
//           id={id}
//           aria-label="text"
//           type={type}
//           variant="outlined"
//           placeholder={placeH}
//           value={value ?? ""}
//           onChange={handleInputChange}
//           onBlur={onBlur}
//           inputRef={inputRef}
//           label={label}
//           error={error}
//           helperText={helperText || `Press Enter or click "+" to add values (Max: ${maxValues})`}
//           name={name}
//           onKeyDown={onKeyDown}
//           className={cssClass || ""}
//           disabled={disabled || values?.length >= maxValues}
//           slotProps={{
//             input: {
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton onClick={handleAddValue} disabled={!inputValue.trim() || values?.length >= maxValues}>
//                     <AddIcon />
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             },
//           }}
//         />
//         <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>
//           {values.map((val, index) => (
//             <Chip key={index} label={val} onDelete={() => handleDelete(val)} />
//           ))}
//         </Box>
//       </FormControl>
//     </div>
//   );
// };

// export default GlobalMultiTextField;
